import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import * as serviceWorker from './serviceWorker';
import { BrowserRouter as Router,Switch,Route} from "react-router-dom";

import Naruto from './naruto/Naruto'
import App from './App';
import Haikyuu from './Haikyuu/Haikyuu'

import Footer from "./other/footer"
import Header from "./other/header"

const Root = () => (


  <Router>
          <Switch>
  
          

            <Route path="/naruto">
              <Naruto />
              <Footer />
            </Route>

            <Route path="/Haikyuu">
              <Haikyuu />
              <Footer />
            </Route>

          <Route path="/">
              <Header />
              <App />
              <Footer />
            </Route>


          </Switch>
  </Router>


)





ReactDOM.render(<div>
  <Root /></div>,
document.getElementById('root')
);



serviceWorker.unregister();
